import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filtro',
    standalone: false
})

export class FiltroPipe implements PipeTransform {

  transform(items: any[], field: string, value: string): any[] {
    if (!items) return [];
    if (!value) return items;
    return items.filter(it => it[field].toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").indexOf(value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")) !== -1);
  }

}
